let entity = "DOCUMENT_STATE"
export const GET_ALL = `GET_ALL_${entity}`
export const GET_ALL_SUCCESS = `GET_ALL_SUCCESS_${entity}`
export const GET_ALL_FAIL = `GET_ALL_FAIL_${entity}`
